import { PageId } from 'constants/pages'

export const enum PageIdWoofzXmas80 {
  SUBSCRIPTIONS_XMAS_80 = PageId.SUBSCRIPTIONS_XMAS_80,
  CHAT_UPSELL_XMAS_80 = PageId.CHAT_UPSELL_XMAS_80,
  UPSELL_XMAS_80 = PageId.UPSELL_XMAS_80,
  DOWNLOAD_XMAS_80 = PageId.DOWNLOAD_XMAS_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
